import { css, styled } from 'styled-components';

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.typography.sizes.lg};
    font-weight: 600;
    text-align: center;
    margin-bottom: ${theme.spaces.padding.md};
  `}
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 360px;
  padding: 0;
`;
